import React from 'react'
import { PaymentSuccess } from '../PaymentResult'

export default function ReceiptSuccess({ visible, chargeId, receiptDetails }) {
    if (!visible || !receiptDetails) {
        return null
    }

    return <PaymentSuccess visible={true} chargeId={chargeId} receiptDetails={receiptDetails} />
}
